module.exports = __webpack_public_path__ + "static/media/apartment22.bc48f21b.jpg";